// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2azKa","label":"Completed_label__2_BqR"};